import { AnimatePresence } from 'framer-motion'
import { useCallback, useEffect, useState } from 'react'

import { emitter, MessageAddEvent, MessageRemoveEvent } from './events'
import { Message } from './Message'
import { MessageType } from './type'

const MAX_MESSAGE_NUM = 5

export function MessageContainer() {
  const [messages, setMessage] = useState<MessageType[]>([])

  const addMessage = useCallback((message: MessageType) => {
    setMessage((messages) => [...messages, message].slice(-1 * MAX_MESSAGE_NUM))
  }, [])
  const removeMessage = useCallback((id: string) => {
    setMessage((messages) => messages.filter((message) => message.id !== id))
  }, [])

  useEffect(() => {
    emitter.on(MessageAddEvent, addMessage)
    emitter.on(MessageRemoveEvent, removeMessage)

    return () => {
      emitter.off(MessageAddEvent, addMessage)
      emitter.off(MessageRemoveEvent, removeMessage)
    }
  }, [addMessage, removeMessage])

  return (
    <div className="fixed top-10 z-[99] w-full flex flex-col items-center gap-3 pointer-events-none">
      <AnimatePresence>
        {messages.map((message) => (
          <Message key={message.id} message={message} className="pointer-events-auto" />
        ))}
      </AnimatePresence>
    </div>
  )
}
